
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Create root and render app
createRoot(document.getElementById("root")!).render(<App />);
